import { BlogPost, BlogPostFeedItem } from 'containers/blog/post/types';
import { getBlogPost } from 'utils/blog';
import Algorithmics1 from './algorithmics1';
import AutoMlPost from './automl';
import BackpropagationPost from './backpropagation';
import BasicDataPreparationMl from './basicDataPreparationMl';
import CaseStudyExomatter from './caseStudyExomatter';
import CaseStudyOwwn from './caseStudyOwwn';
import EvolutionaryAlgorithmsPost from './evolutionaryAlgorithms';
import IICPost from './iicPost';
import InstaFeedPost from './instafeed';
import NotionDashboardPost from './notionDashboard';
import StorytellingWithVideosPost from './storytellingWithVideos';
import Word2VecPost from './word2vec';

const projects: BlogPost[] = [
  BackpropagationPost,
  EvolutionaryAlgorithmsPost,
  BasicDataPreparationMl,
  CaseStudyOwwn,
  CaseStudyExomatter,
  StorytellingWithVideosPost,
  IICPost,
  Word2VecPost,
  AutoMlPost,
  InstaFeedPost,
  NotionDashboardPost,
  Algorithmics1,
];

export const projectsFeedItems: BlogPostFeedItem[] = projects.sort(
  (item1, item2) => -item1.date.getTime() + item2.date.getTime(),
);

export const getProjectPost = (id: string): BlogPost => getBlogPost(id, projects);
